/* =====================================================================
   Drawer contents on demand (perf 2026-11-02, Alexander: "agree").

   Every page used to carry the contents of four hidden drawers in its HTML: favourites
   bestsellers (~100 KB), the search drawer's eight cards (~85 KB), the country list TWICE
   (2 x 59 KB, 78 flags) and the samples groups (~46 KB) - 300-450 KB, ~2,000 nodes and
   100+ images before anyone clicked anything. The page now ships each drawer with a
   placeholder ([data-lazy-section="<section file>"]) and this script fills them:

     - quietly once the page has drawn (after load, in idle time), or
     - at once when the visitor shows intent: hover, focus or touch on an opener
       (search, heart, menu, market selector, Samples tab), or the click itself.

   ONE request fetches every section still needed (Section Rendering API, ?sections=), so the
   country rows are rendered once and copied into both dialogs. The HTML is the same markup the
   drawers used to print, so global.js and the drawers' own scripts work on it unchanged; the
   few things that were set up at page load are redone here (hooks below).
   ===================================================================== */
(function () {
  'use strict';
  if (window.__lazyDrawers) return;
  window.__lazyDrawers = true;

  var OPENERS = '[data-action="open-search"], [data-toggle-id="favorites-drawer"], [data-toggle-id="Drawer"], ' +
    '[data-action="open-modal"], [data-samples-open]';
  var cache = {};        /* section id -> HTML (inner of its shopify-section wrapper) */
  var inflight = null;
  var retries = 0;

  function searchBar() { return document.getElementById('quickSearch'); }

  /* Placeholders still waiting, in the page and in SearchBar's saved copy of its opening view
     (resetSearch() restores from that copy, so it must hold the cards too). */
  function placeholders() {
    var list = Array.prototype.slice.call(document.querySelectorAll('[data-lazy-section]'));
    var sb = searchBar();
    if (sb && sb.initialSearchLayout && sb.initialSearchLayout.querySelectorAll) {
      list = list.concat(Array.prototype.slice.call(sb.initialSearchLayout.querySelectorAll('[data-lazy-section]')));
    }
    return list;
  }

  function wanted() {
    var ids = [];
    placeholders().forEach(function (p) {
      var id = p.getAttribute('data-lazy-section');
      if (!(id in cache) && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function unwrap(html) {
    var t = document.createElement('template');
    t.innerHTML = html || '';
    var w = t.content.querySelector('.shopify-section');
    return w ? w.innerHTML : t.innerHTML;
  }

  function load() {
    var ids = wanted();
    if (!ids.length) { fill(); return Promise.resolve(); }
    if (inflight) return inflight;
    var root = (window.routes && window.routes.localeRootUrl) || '';
    inflight = fetch(root + '/?sections=' + ids.slice(0, 5).join(','), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        ids.slice(0, 5).forEach(function (id) { cache[id] = unwrap(json[id]); });
        inflight = null;
        fill();
      })
      .catch(function () {
        /* A failed fetch (a 429 under load, a dropped connection) leaves the placeholders. The next
           hover/focus/click tries again, and so do two quiet retries, 5 s and 20 s later. */
        inflight = null;
        if (retries < 2) setTimeout(load, retries++ ? 20000 : 5000);
      });
    return inflight;
  }

  /* Swap each waiting placeholder for its section's nodes, then redo what the drawer set up at
     page load. One section per task, so no single task grows long (a timer, not an animation
     frame: frames stop in a background tab and the swap must not wait on that). */
  function fill() {
    var groups = {};
    placeholders().forEach(function (p) {
      var id = p.getAttribute('data-lazy-section');
      if (id in cache) (groups[id] = groups[id] || []).push(p);
    });
    Object.keys(groups).forEach(function (id, i) {
      setTimeout(function () {
        groups[id].forEach(function (p) {
          if (!p.parentNode) return;
          var t = document.createElement('template');
          t.innerHTML = cache[id];
          p.replaceWith(t.content);
        });
        if (HOOKS[id]) { try { HOOKS[id](); } catch (e) { /* the content is in; a hook must never break the page */ } }
      }, i * 16);
    });
  }

  var HOOKS = {
    /* FavoritesDrawer built its carousel at page load; build it again on the real slides. */
    'lazy-favorites-recommendations': function () {
      var fd = document.querySelector('favorites-drawer');
      var sw = document.querySelector('.favorites__recommendations-swiper');
      if (!fd || !sw || typeof fd.initCarousel !== 'function') return;
      if (sw.swiper) sw.swiper.destroy(true, true);
      fd.initCarousel();
    },
    /* SearchBar starts the opening view's carousel itself (initCarousel); only when the opening
       view is what the drawer shows now, not live results. */
    'lazy-search-recommendations': function () {
      var sb = searchBar();
      var view = sb && sb.querySelector('.searchWrapper .searchInitialView');
      if (view && !view.swiper && typeof sb.initCarousel === 'function') sb.initCarousel();
    },
    /* An open country list was measured on the placeholder: measure it again on the rows. */
    'lazy-localization-countries': function () {
      document.querySelectorAll('.rs-country__selectbox .RevolutionSelectbox--Content[aria-hidden="false"]').forEach(function (c) {
        c.style.height = '';
        var h = c.offsetHeight;
        c.style.height = h + 'px';
      });
    }
  };

  /* Intent: the earliest sign a drawer is about to open. */
  function onIntent(e) {
    var t = e.target;
    if (t && t.closest && t.closest(OPENERS)) load();
  }
  ['pointerover', 'focusin', 'touchstart', 'pointerdown', 'click'].forEach(function (type) {
    document.addEventListener(type, onIntent, { capture: true, passive: true });
  });

  /* A drawer can print its placeholder again later: the favourites drawer re-renders its
     content from /?section_id=saved when the list empties. Fill those from the cache. */
  if ('MutationObserver' in window) {
    var fd = document.querySelector('favorites-drawer');
    if (fd) {
      new MutationObserver(function () {
        if (fd.querySelector('[data-lazy-section]')) load();
      }).observe(fd, { childList: true, subtree: true });
    }
  }

  /* Quietly, once the page has drawn. */
  function idle() {
    var go = function () { load(); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 });
    else setTimeout(go, 1500);
  }
  if (document.readyState === 'complete') idle();
  else window.addEventListener('load', idle);
})();
